import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { exportOsagoFailed, exportOsagoSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* exportOsago(action) {
  try {
    const url = `${BACKEND_URL}/resources/manual-check-logs/export/osago`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(exportOsagoSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(exportOsagoFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(exportOsagoFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
